import { createIcon } from './createIcon';

/**
 * Downward chevron — a disclosure indicator for anything that opens in place
 * or drops a menu. Callers that flip it when open rotate it with CSS rather
 * than swapping in a second glyph.
 */
export const ChevronDownIcon = createIcon({
  name: 'ChevronDownIcon',
  viewBox: '0 0 12 12',
  size: 12,
  children: (
    <path
      d="M3 4.5 6 7.5 9 4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export default ChevronDownIcon;
